import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {OrganizationType} from '../../types/organization/organization-type';
import {AbstractSelectComponent} from '../common/abstract-select-component';
import {OrganizationTypeRestService} from '../../services/oganization/organization-type-rest.service';

@Component({
  selector: 'wsd-select-organization-type',
  templateUrl: './select-organization-type.component.html',
  styleUrls: ['./select-organization-type.component.css']
})
export class SelectOrganizationTypeComponent extends AbstractSelectComponent<OrganizationType> implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Output()
  private onChange = new EventEmitter<void>();

  constructor(private orgTypeService: OrganizationTypeRestService) {
    super('SELECT_ORGANIZATION_TYPE.LABEL', 'SELECT_ORGANIZATION_TYPE.PLACEHOLDER', 'organizationType');
  }

  ngOnInit() {
    this.init();
  }

  protected init() {
    this.items = [];
    this.orgTypeService.getAllOrganizationTypes().subscribe(
      (data: OrganizationType[]) => {
        for (const item of data) {
          this.items.push({
            label: item.name,
            value: item
          });
          if (this.parentForm.get(this.controlName) &&
            this.parentForm.get(this.controlName).value &&
            this.parentForm.get(this.controlName).value.id === item.id) {
            this.parentForm.get(this.controlName).setValue(item);
          }
        }
      }
    );
  }

  change() {
    this.onChange.emit();
  }
}
